// extracted by mini-css-extract-plugin
export var body = "_md-0";
export var sectionHeader = "_md-4";
export var shortcutColumns = "_md-2";
export var shortcutList = "_md-1";
export var shortcutSection = "_md-3";